import { useCallback, useEffect, useState } from 'react';
export default ({
  eventName,
  getFunction,
  manager,
  ssr = true
}) => {
  const [value, setValue] = useState(ssr ? getFunction() : null);
  const onChange = useCallback(() => {
    setValue(getFunction());
  }, [manager, getFunction]);
  useEffect(() => {
    const newValue = getFunction();
    if (newValue !== value) {
      setValue(newValue);
    }
    if (manager) {
      manager.on(eventName, onChange);
      return () => {
        manager.off(eventName, onChange);
      };
    }
  }, [manager, onChange]);
  return value;
};